import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIssueRacking = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 0v8H0V0h20zm-2 2H2v4h16V2zm2 8v8H0v-8h20zm-2 2H2v4h16v-4z",
		fill: "#111"
	})
});
export default SvgIssueRacking;
